import template from './features_roles_component.html';
import tr from '../../lib/default-translator.js';
import * as Utils from '../../lib/savanna_utils.js';


class AdminFeaturesRolesComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.feature_roles = ko.observableArray();
		this.access_roles = ko.observableArray();
		this.selectedRoles = ko.observableArray();
		this.selected_category = ko.observable('Employee');

		this.filtered_feature_roles = ko.pureComputed(() => {
			let selected_category = this.selected_category();
			return ko.utils.arrayFilter(this.feature_roles(), (fr) => {
				return fr.category === selected_category;
			});
		});

		this.selected_category.subscribe((newCategory) => {
			$('.ps-tabs > li').removeClass('active');
			$(`.ps-tabs > li[data-tabname=${newCategory}]`).addClass('active');
		});

		$(`.ps-tabs > li[data-tabname=${this.selected_category()}]`).addClass('active');

		this.save_feature = this.save_feature.bind(this);
		// PAGE LOAD
		this.init();
	}

	switch_tabs(v, e)
	{
		let tabname = e.currentTarget.getAttribute('data-tabname');
		this.selected_category(tabname);
	}

	edit_feature(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().next();

		view_row.hide();
		edit_row.show();
	}

	cancel_edit(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent().parent();
		view_row.show();
		edit_row.hide();
	}

	async save_feature(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		let data = ko.mapping.toJS(v);

		let res = await Grape.fetches.postJSON('/admin/save_feature_roles', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully Saved Feature.'), title: tr('Success')});
			this.updateData();
			edit_row.hide();
			//location.reload();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			this.updateData();
		}
		else if (res.error)
		{
			Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error')});
			this.updateData();
		} 
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});

		view_row.show();
		edit_row.hide();
	}

	async updateData()
	{
		try {
			let options = {
				table: 'v_feature_roles',
				schema: 'savanna',
				limit: 1000000
			}
			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status == 'OK')
			{
				if (res.records != null || res.records != undefined)
					this.feature_roles(res.records);
			}
		} catch (error)
		{
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Could not load feature roles.'});
			console.error(error);
		}

		try {
			let options = {
				table: 'access_role',
				schema: 'grape',
				limit: 1000000,
				sortfield: 'role_name',
				sortorder: 'ASC',
				filter: [{
						value: ['guest','admin','manager','employee','accountant','general_manager','all','developer','director'],
						operand: 'IN',
						field: 'role_name'
					}]
			
			};

			let res = await Grape.fetches.getJSON('/api/record', options);
			

			if (res.status == 'OK')
			{
				if (res.records != null || res.records != undefined)
					this.access_roles(res.records);
			}
	
			Utils.refresh_data_visible_roles();
		
		} catch (error)
		{
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Could not load access roles.')});
			console.error(error);
		}
	};

	async init()
	{
		await this.updateData();
		let res = await Grape.fetches.getJSON('/settings/get_users_access_roles')
		if (res.status != 'ERROR')
			this.access_roles(res.records);
	}
};

export default {
	name: 'features_roles_component',
	viewModel: AdminFeaturesRolesComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/features_roles_component'
};
